import aframe from "aframe";
import { bindEvent } from "aframe-event-decorators";
import gameState from "./game-state";

const explosionTime = 3000;

aframe.registerComponent("game-over", {
  init() {
    this.messageText = this.el.querySelector("[text__message]");
    this.scoreText = this.el.querySelector("[text__finalscore]");
    this.menuElements = this.el.querySelector("#gameOverMenuElements");
    this.explosion = this.el.querySelector("[game-over-explosion]");

    this.timer = 0;
  },
  gamestatechanged: bindEvent({ target: "[game-state]" }, function(evt) {
    const newState = evt.detail;
    if (newState === "GameOver") {
      this.el.setAttribute("visible", true);
      this.el.setAttribute("paused", false);
      this.timer = 0;
      this.menuElements.setAttribute("visible", false);
      this.scoreText.setAttribute("text__finalscore", "value", gameState.score);

      const isHighScore = document
        .querySelector("[high-scores]")
        .components["high-scores"].isHighScore(gameState.score);

      this.messageText.setAttribute(
        "text__message",
        "value",
        isHighScore ? "HIGH    SCORE" : "THE    END"
      );

      if (isHighScore) {
        const characterEls = this.el.querySelectorAll(
          ".character [text__character]"
        );
        for (let i = 0; i < characterEls.length; i++) {
          characterEls[i].setAttribute(
            "text__character",
            "value",
            i < 3 ? "A" : "_"
          );
        }
        document.querySelector("#enterName").setAttribute("visible", true);
        document
          .querySelector("#tryAgainButton")
          .setAttribute("visible", false);
      } else {
        document.querySelector("#enterName").setAttribute("visible", false);
        document.querySelector("#tryAgainButton").setAttribute("visible", true);
      }

      this.explosion.setAttribute("game-over-explosion", {
        growTime: explosionTime / 1000,
        fadeTime: explosionTime / 1000
      });
      this.explosion.components["game-over-explosion"].reset();
    } else {
      this.el.setAttribute("visible", false);
      this.el.setAttribute("paused", true);
    }
  }),
  vrbuttonup: bindEvent(function(evt) {
    const buttonId = evt.target.id;

    if (buttonId === "tryAgainButton") {
      document
        .querySelector("[game-state]")
        .setAttribute("game-state", { state: "MainMenu" });
    } else if (buttonId === "doneNameButton") {
      document
        .querySelector("#highScoreTable")
        .components["high-scores"].addHighScore(
          this.getName(),
          gameState.score
        );
      document
        .querySelector("[game-state]")
        .setAttribute("game-state", { state: "MainMenu" });
    }
  }),
  getName() {
    let name = "";
    const characterEls = this.el.querySelectorAll(
      ".character [text__character]"
    );
    for (let i = 0; i < characterEls.length; i++) {
      name += characterEls[i].getAttribute("text__character").value;
    }
    return name;
  },
  tick(t, dt) {
    this.timer += dt;
    if (this.timer >= explosionTime) {
      this.menuElements.setAttribute("visible", true);
    }
  }
});
